import { KEY_RE } from './constants.ts'

/**
 * Live formatter for the CloudPass key field: uppercase, keep letters/digits only, group by 4 with dashes,
 * max 16 characters. Safe for typing and for pasting (with or without dashes, any case, stray spaces).
 */
export function formatKeyInput(raw: string): string {
  const chars = raw.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 16)
  return chars.match(/.{1,4}/g)?.join('-') ?? ''
}

/** True when the value is a complete key in CloudPass format (no ambiguous 0/O/1/I). */
export const isCompleteKey = (v: string) => KEY_RE.test(v.trim().toUpperCase())
